module.exports = __webpack_public_path__ + "static/media/Host_Available_Property_Unregulated.78c01bc1.png";